angular.module('shared').factory('PushNotificationValidationService', ["$filter", function($filter) {
  return {
    clean: function(content) {
      var cleanContent, mergeTagPlaceholder;
      cleanContent = this.decodeHTML($filter('sanitizeEditorField')(content || ''));
      mergeTagPlaceholder = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].join('');
      return cleanContent.replace(/(<mark>.+?<\/mark>)/g, mergeTagPlaceholder);
    },
    decodeHTML: function(html) {
      if (!this.txt) {
        this.txt = document.createElement('textarea');
      }
      this.txt.innerHTML = html;
      return this.txt.value;
    },
    getRemainingCharacters: function(content) {
      return 2800 - this.clean(content).length;
    },
    isLengthValid: function(content) {
      return this.getRemainingCharacters(content) >= 0;
    },
    displayRemainingCharacters: function(content) {
      var charactersLabel, remaining;
      remaining = this.getRemainingCharacters(content);
      charactersLabel = remaining === 1 || remaining === (-1) ? 'character' : 'characters';
      if (remaining < 0) {
        return `Character limit exceeded: please remove ${-remaining} ${charactersLabel}.`;
      }
    }
  };
}]);
